/**************************************************
 * Nombre:       Seccion_Home
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Home_Anuncios from "./Apartados/Home_Anuncios";
import Home_Marcas from "./Apartados/Home_Marcas";
import Home_Categorias from "./Apartados/Home_Categorias";
import Home_Pagos from "./Apartados/Home_Pagos";
import Home_Agenda_Cita from "./Apartados/Home_Agenda_Cita";
import Home_Mas_Vendidos from "./Apartados/Home_Mas_Vendidos";
import Home_Tiempo_Limitado from "./Apartados/Home_Tiempo_Limitado";
import Home_Contactos from "./Apartados/Home_Contactos";
import Testimonios from "./Componentes/Testimonios";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";

const Seccion_Home = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Home_Anuncios/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 4}}>
                <Home_Marcas/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 4}}>
                <Home_Categorias/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 12}}>
                <Home_Pagos/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 6}}>
                <Home_Agenda_Cita/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 12}}>
                <Home_Mas_Vendidos/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 12}}>
                <Home_Tiempo_Limitado/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 4}}>
                <Home_Marcas/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 4}}>
                <Home_Contactos/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: sCell ? -2 : 0}}>
                <Testimonios/>
            </Grid>

        </Grid>
    )

}
export default Seccion_Home